import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'


const headerSocials = () => {
  return (
    <div className="header__socials">
        <a href="https://www.linkedin.com/in/michael-d-fang/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><BsLinkedin/></a>
        <a href="https://github.com/FlyinPandaa" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><BsGithub/></a>
    </div>
  )
}

export default headerSocials
